import React from 'react';
import ContactFormHelper from './ContactForm/ContactFormHelper';
import { Wrapper} from './styles';



export const Contact = () => {

  return (
    <Wrapper id="contact"> 
        <ContactFormHelper />
    </Wrapper>
  );
};

export default Contact;
